import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import './Products.css';
import about1 from '../assets/about1.jpg';
import about2 from '../assets/about1.jpg';
import service1 from "../assets/service1.png";
import service2 from "../assets/service2.jpg";
import service3 from "../assets/service3.jpg";
import Header from '../components/Header';
import Footer from '../components/Footer';
import AOS from 'aos';
import 'aos/dist/aos.css';

function Products({ showHeader = true, showFooter = true }) {
  const navigate = useNavigate();

  // Initialize AOS
  useEffect(() => {
    AOS.init({
      duration: 1200,    // animation duration
      easing: "ease-out",
      once: false,       // animate every time it enters viewport
      mirror: true       // allow fade-out when scrolling up
    });
  }, []);

  const products = [
    {
      id: 1,
      title: 'Custom Ducts (manufactured in-house)',
      image: service1,
      description: `Our custom ducts are precision-engineered in our state-of-the-art in-house factory. 
They are designed to meet exact site specifications and ensure optimal airflow efficiency. 
We offer a wide variety of duct types including spiral, rectangular, flat, L-shaped, and collar fittings. 
Special custom-shaped ducts are also available for unique project requirements. 
Each duct undergoes strict quality checks to ensure durability and performance. 
On-time delivery and seamless installation are guaranteed for all commercial and residential projects.`,
      details: {
        types: ["Spiral ducts", "Rectangular ducts", "Flat ducts", "L-shaped ducts", "Collar fittings", "Special/custom-shaped ducts"],
        table: [
          { property: "Material", value: "Galvanized / Aluminum" },
          { property: "Customization", value: "Available" },
          { property: "Quality Check", value: "100% Tested" }
        ],
        points: [
          "Custom dimensions as per site",
          "High airflow efficiency",
          "On-time delivery"
        ]
      }
    },
    {
      id: 2,
      title: 'AC Units / Installations',
      image: service2,
      description: `We provide expert installation services for Samsung and Carrier AC units. 
Our technicians ensure safe, clean, and efficient installation for both residential and commercial sites. 
Each installation is tailored to the site layout to maximize cooling performance and energy efficiency. 
We handle both small-scale and large-scale projects with complete documentation and adherence to brand standards. 
Our team works closely with project managers and builders to ensure timely execution. 
Customer satisfaction is our top priority on every project we undertake.`,
      details: {
        types: ["Samsung AC Installation", "Carrier AC Installation"],
        table: [
          { property: "Service Type", value: "Installation" },
          { property: "Coverage", value: "Commercial & Residential" }
        ],
        points: [
          "Expert technicians",
          "Safe and clean installation",
          "Site-specific customization"
        ]
      }
    },
    {
      id: 3,
      title: 'Related HVAC Components',
      image: service3,
      description: `Our in-house production unit manufactures high-quality HVAC components and duct accessories. 
These components are designed to seamlessly integrate with AC systems and custom ducts. 
We provide durable fittings and accessories that comply with all industry standards. 
Customization is available to meet unique project requirements. 
Each component is quality-checked to ensure precision and reliability. 
Our products are trusted by contractors across multiple commercial and residential projects.`,
      details: {
        types: ["Fittings", "Accessories"],
        table: [
          { property: "Material", value: "High-quality metal" },
          { property: "Customization", value: "Available" }
        ],
        points: [
          "Produced in-house",
          "Durable and precise",
          "Compatible with all ducts and AC systems"
        ]
      }
    }
  ];

  const handleReadMore = (product) => {
    navigate("/product-details", { state: { product } });
  };

  return (
    <>
      {showHeader && <Header />} {/* Conditional Header */}

      <div className="products-container">
        <h3 style={{
          fontSize: "20px",
          color: "orangered",
          fontWeight: "700",
          textAlign: "center"
        }}>
          DISCOVER PREMIUM AC SOLUTIONS
        </h3>
        <br />
        <p style={{
          fontSize: "25px",
          color: "#0d1b55",
          textAlign: "center",
          marginTop: "8px",
          fontWeight: "800",
          marginBottom: "30px"
        }}>
          Explore our range of high-quality AC and HVAC products
        </p>

        <div className="products-row">
          {products.map((product, i) => (
            <div
              key={product.id}
              className="product-card"
              data-aos="fade-up"           // Fade in from bottom
              data-aos-delay={i * 300}     // Stagger cards one by one
              data-aos-once="false"
            >
              <div className="product-image-wrapper">
                <img
                  src={product.image}
                  alt={product.title}
                  className="product-image"
                />
              </div>
              <div className="product-content">
                <h3 className="product-title">{product.title}</h3>
                <button className="read-more-btn" onClick={() => handleReadMore(product)}>
                  Read More <span className="arrow">›</span>
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>

      {showFooter && <Footer />} {/* Conditional Footer */}
    </>
  );
}

export default Products;
